import type { FaireProductEntity } from "../../entity_types/product";

export const p_vcrs7dwt8m: FaireProductEntity = {
  token: "p_vcrs7dwt8m",
  type: "product",
  name: "Palo Santo Sacred Room Spray – Clearing & Centering",
  brandToken: "b_7zsr03d53s",
  brandName: "Cedar and Myrrh",
  imageUrl:
    "https://cdn.faire.com/fastly/68a714e74f96fd9eb1970b92b271767f60dd5919b9d60b54a9f096548818df53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07457d1195adcf3562f5bcd7540847d1e869beb5ac58d9f1bd0ee3091a06631a.jpeg",
    "https://cdn.faire.com/fastly/022c25d150d766886fcd72e72caecb7e4eb7d75736ac3d42cfca04271493b576.jpeg",
    "https://cdn.faire.com/fastly/7c9dee62bdc99077e38c5e3ce9cc8a27370e56c22ab0077d5f91223f850408b1.jpeg",
  ],
  priceDollars: 15,
  description:
    "• Please note: The formula has been upgraded to feature a higher essential oil ratio, using organic alcohol and distilled water for a deeper, longer-lasting aroma.\n\n• Rich, grounding aroma of Palo Santo to clear stagnant energy and create space for focus and renewal\n\n• Crafted with pure Palo Santo essential oil, offering a warm, woody aroma with subtle citrus and resinous notes rooted in sacred tradition.\n\n• Made with organic alcohol and distilled water for a clean, long-lasting aroma that elevates any room.\n\n• Perfect for spiritual practices, daily rituals, or mindful transitions between tasks.\n\n• Use in your home, meditation space, or creative studio to support inner clarity and emotional balance.\n\n• Safe for use in the air, on linens, and in personal spaces (not intended for direct skin contact).\n\n• Free from synthetic fragrances, artificial preservatives, and harsh chemicals.\n\n• Handcrafted in small batches by Cedar and Myrrh.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:13.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
